import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CalendarMonthOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M22 3V19C22 20.6543 20.6543 22 19 22H5C3.3457 22 2 20.6543 2 19V3H7V2H9V3H15V2H17V3H22ZM20 5H17V7H15V5H9V7H7V5H4V19C4 19.5513 4.44824 20 5 20H19C19.5518 20 20 19.5513 20 19V5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M7 10H9V12H7V10Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M7 14H9V16H7V14Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M15 10H17V12H15V10Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M15 14H17V16H15V14Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M11 10H13V12H11V10Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M11 14H13V16H11V14Z",
    fill: "currentColor"
  }));
}